import React from 'react';

import { GutCheck } from '../games/GutCheck.game';
import { ShapeFocus } from '../games/ShapeFocus.game';
import { NotificationRush } from '../games/NotificationRush.game';
import { CatchThePhish } from '../games/CatchThePhish.game';

import { IMcsaGameCatalogItem, IMcsaWorld } from '../../../../types/mcsa.interface';
import { MCSA_JOURNEY_COPY } from '../../../../helpers/mcsa-journey.copy';
import { MCSA_WORLD_THEME } from '../../../../helpers/mcsa-world.theme';

interface JourneyGameHostProps {
    world: IMcsaWorld;
    game: IMcsaGameCatalogItem;
    gameNum: number;
    gameTotal: number;
    muted?: boolean;
    onSkip: () => void;
    onComplete: () => void;
    onBackToMap: () => void;
}

export const JourneyGameHost = (props: JourneyGameHostProps) => {
    const { world, game, gameNum, gameTotal, muted = false, onSkip, onComplete, onBackToMap } = props;
    const accent = MCSA_WORLD_THEME[world.key].accent;

    return (
        <div className={`mcsa_journey_stage mcsa_journey_stage--${world.key} mcsa_journey_stage--game`}>
            <div className='mcsa_journey_game__bar'>
                <button type='button' className='mcsa_journey_stage__map' style={{ color: accent }} onClick={onBackToMap}>
                    ← {MCSA_JOURNEY_COPY.back_to_map_short}
                </button>
                <span className='mcsa_journey_game__badge' style={{ background: accent }}>
                    {game.badge} {gameNum}/{gameTotal}
                </span>
                <span className='mcsa_journey_game__blurb'>{game.blurb}</span>
                <button type='button' className='mcsa_journey_game__skip' onClick={onSkip}>
                    {MCSA_JOURNEY_COPY.skip_game} →
                </button>
            </div>
            <div className='mcsa_journey_game__frame'>
                {game.key === 'gut_check' && <GutCheck onComplete={onComplete} />}
                {game.key === 'shape_focus' && <ShapeFocus onComplete={onComplete} muted={muted} />}
                {game.key === 'notification_rush' && <NotificationRush onComplete={onComplete} muted={muted} />}
                {game.key === 'catch_the_phish' && <CatchThePhish onComplete={onComplete} />}
            </div>
        </div>
    );
};
